import { END_POINTS } from "../constants/url";
import { CommonBody } from "../types/General";
import emptySplitApi from "../utils/rtk";

interface CommonResponseType {
  status: number;
  message: string;
  statusCode: number;
}

export const CustomerSupportApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getCustomerSupport: builder.query<
      CommonResponseType & { data: any },
      {
        search?: string;
        length?: number;
        start?: number;
        type?: number;
      }
    >({
      query: ({ length, search, start, type }) => ({
        url: `${END_POINTS.getCustomerSupport}?type=${type}&start=${start}&length=${length}&search=${search}`,
        method: "POST",
      }),
    }),
    getCustomerSupportById: builder.query<
      CommonResponseType & { data: any },
      {
        id: number;
      }
    >({
      query: ({ id }) => ({
        url: `${END_POINTS.getCustomerSupportById}${id}/`,
        method: "GET",
      }),
    }),
    updateCustomerSupport: builder.mutation<
      CommonResponseType,
      { body: any; id: number }
    >({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateCustomerSupport}${id}/`,
        method: "POST",
        body,
      }),
    }),

    deleteCustomerSupport: builder.mutation<CommonResponseType, { id: number }>(
      {
        query: ({ id }) => ({
          url: `${END_POINTS.deleteCustomerSupport}${id}/`,
          method: "DELETE",
        }),
      }
    ),
  }),
});

export const {
  useLazyGetCustomerSupportQuery,
  useLazyGetCustomerSupportByIdQuery,
  useUpdateCustomerSupportMutation,
  useDeleteCustomerSupportMutation,
} = CustomerSupportApi;
